<template>
  <div class="payments card">
    <div>
      <p class="font-semibold text-deepBlue font-lg">Payment Information</p>
    </div>
    <div>
      <p class="font-semibold py-2">Payment Card</p>
    </div>
    <div class="container-fluid my-4">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6 ">
          <div
            class="user-card w-full md:w-3/4 text-white px-4 py-2"
            v-if="
              contact.paymentInformation &&
                contact.paymentInformation.paymentCard &&
                userCard
            "
          >
            <div class="pt-2">
              <img
                src="@/assets/images/icons/mastercard.svg"
                alt="mastercard logo"
                v-if="userCard.cardType == 'Mastercard'"
              />
            </div>
            <div class="flex justify-between py-6">
              <!-- <span>4569</span>
              <span>3675</span>
              <span>1427</span>
              <span>3675</span> -->
              <span>{{ userCard.cardNumber }}</span>
            </div>
            <div class="flex justify-between pb-2">
              <div>
                <p class="text-xs">CARD HOLDER</p>
                <p class="text-sm">{{ userCard.cardName }}</p>
              </div>
              <div>
                <p class="text-xs">EXP</p>
                <!-- <p class="text-sm">08/02</p> -->
              </div>
            </div>
          </div>
          <div v-else>
            <p class="text-sm pt-2">This contact has no registered card!</p>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="w-full md:w-3/4 ">
            <div>
              <label class="label">Card Name:</label>
              <input
                type="text"
                class="input"
                placeholder="Enter name"
                v-model="card.cardName"
              />
            </div>
            <div>
              <label class="label">Card Type:</label>
              <!-- <input type="text" class="input" placeholder="Select" /> -->
              <el-select v-model="card.cardType" placeholder="Select">
                <el-option
                  v-for="type in cardTypes"
                  :key="type"
                  :label="type"
                  :value="type"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <label class="label">Card Number:</label>
              <input
                type="text"
                class="input"
                placeholder="Enter card number"
                @keydown="isNumber"
                v-model="card.cardNumber"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="container-fluid my-4">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6">
          <div>
            <p class="font-semibold">Wallet</p>
            <p class="text-sm">ID: {{ contact.code }}</p>
          </div>
          <div class="user-wallet w-full md:w-3/4  px-4 py-2 mt-4">
            <div class="flex justify-between pt-4 pb-6">
              <div>
                <img src="@/assets/images/icons/wallet.svg" alt="Wallet icon" />
                <p class="font-bold text-lg">₦00.00</p>
                <p class="text-xs">Today, {{ currentDate }}</p>
              </div>
              <div>
                <div
                  class="bg-darkBlue text-white font-semibold rounded px-2 py-1 cursor-pointer"
                  @click="isPaymentModal = true"
                >
                  Top Up
                </div>
              </div>
            </div>
            <div class="flex pb-6">
              <div class="flex mr-4">
                <img
                  src="@/assets/images/icons/uptrend.svg"
                  alt="up trend icon"
                />
                <p>+ ₦00.00</p>
              </div>
              <div class="flex">
                <img
                  src="@/assets/images/icons/downtrend.svg"
                  alt="down trend icon"
                />
                <p>- ₦00.00</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="flex justify-between">
            <p class="font-semibold">Transaction History</p>
            <p class="cursor-pointer underline">View All</p>
          </div>
          <div class="mt-4 w-full">
            <table class="w-full">
              <thead>
                <tr>
                  <th>Transaction No.</th>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody v-if="contact.walletTransactions">
                <tr v-for="n in 7" :key="n">
                  <td>MX0986642443</td>
                  <td>22 Apr 2021</td>
                  <td class="flex">
                    <img
                      src="@/assets/images/icons/downtrend.svg"
                      alt="down trend icon"
                    />
                    <span>- ₦95,240.80</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!contact.walletTransactions">
              <div class="flex justify-center py-4">
                <empty-table-icon />
              </div>
              <p class="text-sm text-center">
                No transactions for this user yet!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="my-8">
      <primary-button
        buttonText="Apply Changes"
        :loading="loading"
        @click="updateContact"
      />
    </div>

    <payment-modal
      :show-modal="isPaymentModal"
      @close-modal="isPaymentModal = false"
    />
  </div>
</template>

<script>
import PaymentModal from "@/components/UI/Modal/PaymentModal";

export default {
  name: "payments",
  components: {
    PaymentModal,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      card: {
        cardName: "",
        cardType: "",
        cardNumber: "",
      },
      cardTypes: ["Mastercard", "Visa", "Verve"],
      isPaymentModal: false,
      loading: false,
      userCard: this.contact.paymentInformation
        ? this.contact.paymentInformation.paymentCard[0]
        : null,
    };
  },
  computed: {
    currentDate() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      // today = mm + "/" + dd + "/" + yyyy;
      today = `${dd} ${months[mm - 1]}, ${yyyy}`;
      return today;
    },
  },
  methods: {
    async updateContact() {
      this.loading = true;

      let orgId = localStorage.getItem("organizationId");
      const payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: {
          paymentInformation: {
            paymentCard: [this.card],
          },
        },
      };
      try {
        const response = await this.$_updateContact(this.contact.id, payload);
        this.logResponse(response);
        this.generateToast("Contact updated successfully!", "success");
        this.resetCard();
        this.$emit("contact-updated");
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    resetCard() {
      this.card = {
        cardName: "",
        cardType: "",
        cardNumber: "",
      };
    },
  },
};
</script>

<style scoped>
.label {
  margin-top: 1rem;
}
.input {
  margin-bottom: 0;
}
.user-card {
  background: #4f5c6a;
  border-radius: 10px;
}
.user-wallet {
  background: #fafbfd;
  border: 1px solid #2c445c;
  border-radius: 10px;
}
td,
th {
  padding: 0.5rem;
}
</style>
